export function buildUrl(base: string, params?: Record<string, string | number | boolean | undefined>): string {
  const url = new URL(base, window.location.origin);

  if (params) {
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== null && value !== "") {
        url.searchParams.set(key, String(value));
      }
    }
  }

  return url.toString();
}

export function getQueryParams(): Record<string, string> {
  const params = new URLSearchParams(window.location.search);
  const result: Record<string, string> = {};

  for (const [key, value] of params.entries()) {
    result[key] = value;
  }

  return result;
}

export function setQueryParams(params: Record<string, string | number | boolean>): void {
  const url = new URL(window.location.href);

  for (const [key, value] of Object.entries(params)) {
    url.searchParams.set(key, String(value));
  }

  window.history.replaceState({}, "", url.toString());
}

export function clearQueryParams(): void {
  const url = new URL(window.location.href);
  url.search = "";
  window.history.replaceState({}, "", url.toString());
}

export function isExternalUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    return parsed.origin !== window.location.origin;
  } catch {
    return false;
  }
}
